var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scheduleContainerWrapper"},[_c('br'),_c('ScheduleForm',{on:{"deleteReport":function($event){return _vm.deleteReport($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }